import { useParams } from "react-router";

import { skipToken } from "@reduxjs/toolkit/query/react";

import type { SinglePageCheckoutRoutesParams } from "@jti/fe-common";
import { useGetCustomerOrderQuery } from "@jti/store/slices/magentoApiSlice";

export const useCustomerOrder = (orderNumber?: string) => {
  const { orderNumber: orderNumberFromRoute } = useParams<SinglePageCheckoutRoutesParams>();
  const orderQueryState = useGetCustomerOrderQuery(orderNumber ?? orderNumberFromRoute ?? skipToken);

  return orderQueryState;
};
